import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Chip,
  Typography,
  Box,
} from '@mui/material';
import { QcChartPoint } from '../../services/qcService';

interface Props {
  points: QcChartPoint[];
}

const RULE_COLORS: Record<string, 'error' | 'warning' | 'default'> = {
  '1-3s': 'error',
  '2-2s': 'error',
  'R-4s': 'error',
  '4-1s': 'warning',
  '10x': 'warning',
  'trend': 'warning',
};

export const WestgardViolationsPanel: React.FC<Props> = ({ points }) => {
  const violationRows = points.filter((p) => {
    const v = p.rule_violations || {};
    return Object.values(v).some((flag) => flag === true);
  });

  if (violationRows.length === 0) {
    return (
      <Box sx={{ p: 2 }}>
        <Typography variant="body2" color="text.secondary">
          Aucune violation Westgard sur cette période. ✓
        </Typography>
      </Box>
    );
  }

  return (
    <TableContainer component={Paper} sx={{ maxHeight: 360 }}>
      <Table size="small" stickyHeader>
        <TableHead>
          <TableRow>
            <TableCell>Date</TableCell>
            <TableCell>Lot</TableCell>
            <TableCell>Échantillon</TableCell>
            <TableCell align="right">Valeur</TableCell>
            <TableCell>Règles violées</TableCell>
            <TableCell>Statut</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {violationRows.map((p) => {
            const rules = Object.entries(p.rule_violations || {})
              .filter(([, v]) => v)
              .map(([k]) => k);
            return (
              <TableRow key={p.id} hover>
                <TableCell>{new Date(p.date).toLocaleString('fr-FR')}</TableCell>
                <TableCell>{p.batch_id || '—'}</TableCell>
                <TableCell>{p.sample_id || '—'}</TableCell>
                <TableCell align="right">{Number(p.value).toFixed(4)}</TableCell>
                <TableCell>
                  {rules.map((r) => (
                    <Chip
                      key={r}
                      label={r}
                      size="small"
                      color={RULE_COLORS[r] || 'default'}
                      sx={{ mr: 0.5, mb: 0.25 }}
                    />
                  ))}
                </TableCell>
                <TableCell>
                  {p.out_of_control ? (
                    <Chip label="HORS CONTRÔLE" size="small" color="error" />
                  ) : (
                    <Chip label="ALERTE" size="small" color="warning" />
                  )}
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default WestgardViolationsPanel;
